import { api } from '../DefaultService';

const ENDPOINT = '/v1/images';

export const getImageAsync = async (id: string): Promise<Blob> => {
  return await api
    .get(`${ENDPOINT}/${id}`, {
      responseType: 'blob',
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

// Base64 string return
export const getImagesAsync = async (ids: string[]): Promise<string[]> => {
  const fileIds: string = ids.join(',');
  return await api
    .get(`${ENDPOINT}`, {
      params: { fileIds },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getFileByFirebaseStorageLinkAsync = async (
  link: string,
): Promise<Blob> => {
  return await api
    .get(`${ENDPOINT}/fireStorage`, {
      responseType: 'blob',
      params: { link },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
